import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";

export const getComprobantesRetencionByFacturas = async (IdFactura, IdProveedor) => {
    const result = await PrivateInterceptorsPR(`Retencion/ComprobanteRetencion/FacturasRetenciones`, 'POST', { IdFactura, IdProveedor });
    return result;
}